import script from "./invoice-record-platform-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-record-platform-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__